// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"664":"43ca9034","787":"b350ab57"}[chunkId] + ".chunk.js";
};